import { createStoreHistorySSO } from '@qadra/frontend-common/redux';
import { customSagas } from './sagas';
import { customReducers } from './reducers';

const { store, history } = createStoreHistorySSO(
  customReducers,
  customSagas,
  process.env.NODE_ENV === 'development'
);

export { store, history };
